import TagManager from 'react-gtm-module';
import services from 'services/services';
import { Nullish } from 'utility-types';

// Import variables
import { TRACKING_TYPES } from '../variables';

// Import helpers
import { convertGenresToBrands } from './helpers';

// Import types
import type { Genre } from 'types/api/products/product';
import { GtmEvent } from 'types/views/gtm';

const { GTM } = TRACKING_TYPES;

const validKeyRegex = new RegExp(/GTM-[A-Z0-9]{7}/, 'g');
// GTM-XXXXXXX

export const initGTM = async () => {
	try {
		const {
			data: { value }
		} = await services.get(`/settings/codes/${GTM}`);
		if (value && validKeyRegex.exec(value)) {
			TagManager.initialize({
				gtmId: value
			});
		} else console.warn(`Provided ${GTM} key is invalid or missing, check your CMS settings`);
	} catch {
		console.error(`Could not fetch your ${GTM} key`);
	}
};

export const sendGTMEvent = ({ event, data }: GtmEvent, genres?: Genre[] | Nullish) => {
	TagManager.dataLayer({ dataLayer: { ecommerce: null } });

	const eventData = { ...data };

	if ('url' in eventData) {
		eventData.url = new URL(eventData.url, window.location.origin).href;
	}

	const brands = genres ? convertGenresToBrands(genres) : null;

	const ecommerce = Object.assign({}, eventData, brands);

	TagManager.dataLayer({
		dataLayer: { event, ecommerce }
	});
};
